import { useQuery } from '@tanstack/react-query'

import { getBundleById } from '@flecto/api/saas'
import type { ParameterID } from '@flecto/types'

type QueryPayload = {
  bundleId: ParameterID
}

export function useQueryGetBundleById({ bundleId }: QueryPayload) {
  return useQuery({
    queryKey: ['QueryGetBundleById', bundleId],
    queryFn: async () =>
      await getBundleById({
        bundleId,
      }),
    enabled: bundleId !== undefined && bundleId !== '',
  })
}
